import React from "react";
import QuestionSingleChoice from "./questions/QuestionSingleChoice";
import QuestionMultiChoice from "./questions/QuestionMultiChoice";
import QuestionRating from "./questions/QuestionRating";
import QuestionText from "./questions/QuestionText";
import IserbaQuestions from "./questions/iserba/IserbaQuestions";
import ProgressBar from "components/shared/ProgressBar";
import OrtivisQuestions from "./questions/ortivis/OrtivisQuestions";

const Question = ({
	quiz,
	quizResults,
	setQuizResults,
	question,
	currentQuestionIndex,
	totalQuestions,
	onAnswer,
	handleNext,
}) => {
	const { type } = question;

	if (
		quiz.id === "d58b69c0-1c30-4473-a1f2-668305ef3f93" ||
		quiz.id === "085787d1-2ac2-450e-bc2b-3ce50906fb01" ||
		quiz.id === "5376a517-4255-4f40-b3ee-777b232902dd" ||
		quiz.id === "5680955c-2187-454b-8892-892a064b23c2"
	) {
		return (
			<>
				<IserbaQuestions
					quiz={quiz}
					question={question}
					onAnswer={onAnswer}
					quizResults={quizResults}
					setQuizResults={setQuizResults}
					handleNext={handleNext}
				/>
			</>
		);
	}

	if (quiz.id === "bb792d8c-5be1-4a72-9ebd-8807dee0d79d") {
		return (
			<>
				<OrtivisQuestions
					quiz={quiz}
					question={question}
					onAnswer={onAnswer}
					quizResults={quizResults}
					setQuizResults={setQuizResults}
					handleNext={handleNext}
				/>
			</>
		);
	}

	return (
		<div className="flex flex-col items-center w-full h-full mt-[20%]">
			{quiz?.config?.show_progress_bar && (
				<div className="w-full mb-4">
					<ProgressBar progress={currentQuestionIndex} total={totalQuestions} />
				</div>
			)}

			{type === "single-choice" && (
				<QuestionSingleChoice
					question={question}
					defaultValue={quizResults?.responses[question.id] || []}
					onAnswer={(value) => onAnswer({ value })}
					handleNext={handleNext}
				/>
			)}

			{type === "multiple-choice" && (
				<QuestionMultiChoice
					question={question}
					defaultValue={quizResults?.responses[question.id] || []}
					onAnswer={(value) =>
						onAnswer({
							value: quizResults?.responses[question.id]?.includes(value)
								? quizResults?.responses[question.id].filter((v) => v !== value)
								: [...(quizResults?.responses[question.id] || []), value],
						})
					}
				/>
			)}

			{type === "rating" && (
				<QuestionRating
					question={question}
					defaultValue={quizResults?.responses[question.id] || 0}
					onAnswer={(value) => onAnswer({ value })}
				/>
			)}

			{type === "text" && (
				<QuestionText
					question={question}
					defaultValue={quizResults?.responses[question.id] || ""}
					onAnswer={(value) => onAnswer({ value })}
				/>
			)}
		</div>
	);
};

export default Question;
